import type {IconSize, IconType} from '@Components/icon-v2/icon.types';

export type AccordionHeaderOpts = {
  /**
   * the padding for the main container of the accordion header. Default: ACCORDION_HEADER_SPACING.MEDIUM
   */
  headerPadding?: AccordionHeaderSpacing;
  /**
   * extra classes given to the header wrapper
   */
  headerClassName?: string;
  /**
   * when true, removes the hover background given to the header when the accordion is open
   */
  removeHeaderHoverStateWhenOpen?: boolean;
};

export type AccordionIconOpts = {
  /**
   * extra classes given to the icon
   */
  iconClassName?: string;
  /**
   * the size of the icon, default: IconSize.SIZE_ICON_24
   */
  iconSize?: IconSize;
  /**
   * the type of icon used, default: IconType.GHOST
   */
  iconType?: IconType;
};
export enum AccordionHeaderSpacing {
  XSMALL = 'spacing-p-2',
  SMALL = 'spacing-p-3',
  MEDIUM = 'spacing-p-4',
  LARGE = 'spacing-p-5',
  CUSTOM = '',
}
